import React from 'react';

const BannerCredenciamentoFull =
  '/hero-images/credenciamento-full-screen.png';
const BannerCredenciamentoMiddle =
  '/hero-images/credenciamento-middle-screen.png';
const BannerCredenciamentoMobile =
  '/hero-images/credenciamento-mobile-screen.png';
import './Banner.style.scss';

export const Banner = () => {
  return (
    <div className="banner">
      <div className="banner__background-content">
        <div className="banner__background-full">
          <img
            src={BannerCredenciamentoFull}
            alt="Banner Alelo"
            loading="eager"
            {...{fetchpriority: 'high'}}
          />
        </div>
        <div className="banner__background-middle">
          <img
            src={BannerCredenciamentoMiddle}
            alt="Banner Alelo"
            loading="eager"
            {...{fetchpriority: 'high'}}
          />
        </div>
        <div className="banner__background-mobile">
          <img
            src={BannerCredenciamentoMobile}
            alt="Banner Alelo"
            loading="eager"
            {...{fetchpriority: 'high'}}
          />
        </div>
      </div>

      <div className="banner__content">
        <div className="banner__text">
          <h1 className="banner__title">Credenciamento Alelo</h1>
          <p>
            Aceite os cartões Alelo no seu negócio e deixe a gente fazer parte
            do seu sucesso!
          </p>
        </div>
      </div>
    </div>
  );
};
